import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export function WhoIsItFor() {
  const forWho = ['Madres primerizas con bebés de 0 a 12 meses', 'Madres agotadas que han probado otros métodos sin éxito', 'Familias que necesitan resultados en poco tiempo', 'Padres que buscan un método flexible y práctico', 'Madres que desean recuperar su descanso sin sentirse culpables'];
  const notForWho = ['Familias con bebés que ya tienen rutinas de sueño establecidas', 'Padres que buscan un método basado solo en dejar llorar al bebé', 'Personas que no están dispuestas a probar un enfoque paso a paso', 'Familias que buscan soluciones instantáneas en una sola noche'];
  return <section className="py-20 bg-cream-dark/30" data-id="element-316">
      <div className="max-w-6xl mx-auto px-6" data-id="element-317">
        <FadeIn data-id="element-318">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brown-dark mb-16" data-id="element-319">
            ¿Es esta guía para ti?
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-320">
          {/* Para quién ES */}
          <FadeIn direction="right" data-id="element-321">
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border-t-4 border-accent h-full" data-id="element-322">
              <h3 className="text-2xl font-serif font-bold text-brown-dark mb-8 flex items-center gap-3" data-id="element-323">
                <div className="w-10 h-10 rounded-full bg-accent/20 flex items-center justify-center" data-id="element-324">
                  <Check className="text-brown" data-id="element-325" />
                </div>
                Sí, esta guía es para ti si...
              </h3>
              <ul className="space-y-5" data-id="element-326">
                {forWho.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-327">
                    <Check className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-328" />
                    <span className="text-brown-dark/80" data-id="element-329">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Para quién NO ES */}
          <FadeIn direction="left" delay={0.2} data-id="element-330">
            <div className="bg-white/60 p-8 md:p-10 rounded-3xl shadow-sm border-t-4 border-brown/30 h-full" data-id="element-331">
              <h3 className="text-2xl font-serif font-bold text-brown-dark/70 mb-8 flex items-center gap-3" data-id="element-332">
                <div className="w-10 h-10 rounded-full bg-brown/10 flex items-center justify-center" data-id="element-333">
                  <X className="text-brown/60" data-id="element-334" />
                </div>
                No es para ti si...
              </h3>
              <ul className="space-y-5" data-id="element-335">
                {notForWho.map((item, index) => <li key={index} className="flex items-start gap-3 opacity-80" data-id="element-336">
                    <X className="w-5 h-5 text-brown/40 flex-shrink-0 mt-0.5" data-id="element-337" />
                    <span className="text-brown-dark/70" data-id="element-338">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}